const DisclaimerInfo = () => {
  return (
    <div className="max-width">
      <h3>Notice of Privacy Practices:</h3>
      <p>
        Effective Date: [Nov. 1st 2025] THIS NOTICE DESCRIBES HOW MEDICAL
        INFORMATION ABOUT YOU MAY BE USED AND DISCLOSED AND HOW YOU CAN GET
        ACCESS TO THIS INFORMATION. PLEASE REVIEW IT CAREFULLY.
      </p>
      <h4>Our commitment to your privacy: </h4>
      <p>
        [Rozwon Consultants LLC, Rozwon Health or Rozwon] is committed to
        protecting the privacy and confidentiality of your personal health
        information (PHI). This notice explains how we use and disclose your PHI
        for treatment, payment, and healthcare operations, as well as other
        legally permitted purposes.
      </p>
      <h4>What is personal health information (PHI)?</h4>
      <p>
        PHI includes identifiable information about your past, present, or
        future physical or mental health or condition, and related healthcare
        services.
      </p>
      <h4>How we collect your information:</h4>
      <p>
        We collect your personal information when you provide it to us directly
        and potentially from third parties involved in your care, such as other
        healthcare providers or insurance companies.
      </p>
      <h4>How we use and disclose your information</h4>
      <p>
        We use and disclose your PHI without your specific authorization for
        purposes such as:
      </p>
      <ul>
        <li>
          <strong>Treatment: </strong>
          Providing, coordinating, and managing your healthcare.
        </li>
        <li>
          {" "}
          <strong> Payment: </strong>Billing and collecting payment for
          services.
        </li>
        <li>
          <strong> Healthcare Operations: </strong>
          Running our practice and evaluating services.
        </li>
        <li>
          <strong> Sharing with other healthcare providers: </strong>
          Sharing information with other providers involved in your care with
          your implied consent.
        </li>
      </ul>
      <h4>Uses and disclosures that require your written authorization:</h4>
      <p>
        Your written authorization is required for certain uses and disclosures,
        including marketing, the sale of your PHI, and most uses of
        psychotherapy notes. You can revoke this authorization in writing, but
        it won't affect past uses or disclosures.
      </p>
      <h4>Your rights regarding your PHI:</h4>
      <p>
        You have several rights concerning your medical information, such as the
        right to access and receive a copy of your PHI, request amendments,
        request an accounting of disclosures, request restrictions on use and
        disclosure, and request confidential communications. You also have the
        right to a paper copy of this notice.{" "}
      </p>
      <h4>Our duties regarding your PHI:</h4>
      <p>
        We are legally required to maintain the privacy of your PHI, provide you
        with this notice, and notify you of any breach of unsecured PHI. We must
        follow this notice but can change its terms, and any changes will apply
        to all PHI we hold.
      </p>
      <h4>How to make a complaint You can file a complaint:</h4>
      <p>
        With us or the Secretary of the U.S. Department of Health and Human
        Services if you believe your privacy rights have been violated, and we
        will not retaliate against you for doing so.
      </p>
      <h4>Contact information:</h4>
      <p>
        For questions about this notice or our privacy practices, please reach
        out via email to the following address: info@rozwon.com
      </p>
    </div>
  );
};
export default DisclaimerInfo;
